var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),_c('bug-report-popup',{staticStyle:{"z-index":"5000000000"}}),_c('health-check-popup',{staticStyle:{"z-index":"6000000000"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }